var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPartitionedStreamStandardEnterprise = function SvgPartitionedStreamStandardEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fill: "#a61fe0",
    d: "M20 2a18 18 0 100 36 18 18 0 100-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.343A6.03 6.03 0 0126.657 17H23v-3.657M21 11v8h8a8 8 0 00-8-8zm-4 2.343V17h-3.657A6.03 6.03 0 0117 13.343M19 11a8 8 0 00-8 8h8v-8zm-2 12v3.657A6.03 6.03 0 0113.343 23H17m2-2h-8a8 8 0 008 8v-8zm7.657 2A6.03 6.03 0 0123 26.657V23h3.657M29 21h-8v8a8 8 0 008-8z",
    fill: "#a61fe0"
  })));
};
export default SvgPartitionedStreamStandardEnterprise;